/* eslint-disable */
const compareDates = (date1: any, date2: any) => {
  return new Date(date1).getTime() > new Date(date2).getTime() ? -1 : 1;
};

export const arraySortByDate = (dataArray: any[]) => {
  const result = [...dataArray].sort((a, b) => compareDates(a.creation_date, b.creation_date));
  return result;
};
